{
  "mapTilerApiKey": "T7HQrA4a6k5eOxDGD6qp",
  "indoorEqualApiKey": "iek_ScxQpnty0VWJIvBqa3S6su4XGIiQ",
  "tilesUrl": "https://tiles.indoorequal.org/",
  "indoorMinZoom": 16
}
